{
  "successTitle": "Check Your Email",
  "successMessage": "We sent a verification link to",
  "instructions": "Click the link in the email to verify your account and complete signup.",
  "expiryNote": "The link will expire in 1 hour",
  "resendButton": "Resend Verification Email",
  "resendingButton": "Sending...",
  "backToLogin": "Back to login",
  "failureTitle": "Verification Failed",
  "errors": {
    "invalidOrExpired": "Invalid or expired verification link. Please request a new one.",
    "genericError": "An error occurred. Please try again.",
    "noEmail": "No email address available. Please sign up again.",
    "resendFailed": "Failed to resend verification email. Please try again."
  }
}
